import React from "react";
import style, { keyframes } from "styled-components";
import CONSTANTS from "../constants";

const Menu = ({ onChange, selection }) => {
  return <Wrapper>{createItems(CONSTANTS.PAGES, onChange, selection)}</Wrapper>;
};
export const createItems = (list, onChange, selection) => {
  return list.map((pageName) => {
    const isSelected = pageName === selection;
    return (
      <Item
        className={`${isSelected ? "selected" : ""}`}
        onClick={onClick(onChange, pageName)}
        key={`${pageName}`}
      >
        {isSelected && <Marker />}
        {pageName}
      </Item>
    );
  });
};
export const onClick = (onChange, value) => {
  return () => {
    onChange(value);
  };
};
const slideLeft = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
const Marker = style.div`
    display: inline-block;
    background: red;
    width: .5em;
    height: 1em;
    position: absolute;
    left: -7px;
    top: 4px;
    opacity: .7;
    animation: ${slideLeft} 2s linear infinite;
`;
const Wrapper = style.ul`
  position: fixed;
  background-color: var(--clouds);
  right:0;
  top:2em;
  border:1px solid #BEBEBE;
  padding:0;
  border-radius: 2px;
  z-index: 100;
  @media only screen and (min-device-width: 320px) and (max-device-width: 479px) {
    top:1.25em;
  }
`;
const Item = style.li`
  list-style: none;
  text-align: right;
  padding: .25em 1em;
  border-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: var(--wet-asphalt);
  position:relative;
  font-family: inherit;
  &:last-child{
    border:none;
  }
  @media only screen and (min-device-width: 320px) and (max-device-width: 479px) {
      font-size: x-large;
      font-weight: bolder;
    }
`;
export default Menu;
